<script lang="ts">
export default {
  name: "statusOrderbuy",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];

    if (val == 0) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--success el-tag--dark",
          style: "color:white;"
        },
        "Abierto"
      );
    }

    if (val == 1) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--info el-tag--dark",
          style: "color:white;"
        },
        "Lanzado"
      );
    }

    if (val == 2) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--warning el-tag--dark",
          style: "color:white;"
        },
        "Aprobacion Pendiente"
      );
    }

    if (val == 3) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--primary el-tag--dark",
          style: "color:white;"
        },
        "Anticipo Pendiente"
      );
    }

    return createElement("");
  }
};
</script>
